import { useParams, Link } from 'react-router-dom'
import "./LogOut.css";

function LogOut() {

    const { group, course } = useParams();
    const url = "/group/"+group+"/course/"+course+"/";

    localStorage.setItem("group", group);
    localStorage.setItem("course", course);


      console.log('group on logout: ',group);
      console.log('course on logout: ', course);

  return <div className="logout">
      <div className="logout_container">
      <p>You have logged out successfully.</p>
      <Link className="btn btn-secondary p-1" to={url}>Back to Login</Link>
      </div>

  </div>;
}

export default LogOut;
